/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./SingleValue.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { components } from '@atlaskit/select';
import { SizeableAvatar } from './SizeableAvatar';
import { getAvatarUrl, isTeam } from './utils';
import { VerifiedTeamIcon } from '@atlaskit/people-teams-ui-public/verified-team-icon';
import { Box, Flex, Inline } from '@atlaskit/primitives/compiled';
var styles = {
  avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
  avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
  avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
var ElementAfter = function ElementAfter(props) {
  var data = props.data.data;
  if (isTeam(data) && data.verified) {
    return /*#__PURE__*/React.createElement(VerifiedTeamIcon, null);
  }
  return null;
};
export var SingleValue = function SingleValue(props) {
  var _props$data = props.data,
    label = _props$data.label,
    data = _props$data.data,
    _props$selectProps = props.selectProps,
    appearance = _props$selectProps.appearance,
    isFocused = _props$selectProps.isFocused;
  return !isFocused ? /*#__PURE__*/React.createElement(components.SingleValue, props, /*#__PURE__*/React.createElement(Flex, {
    xcss: styles.avatarItem
  }, /*#__PURE__*/React.createElement(SizeableAvatar, {
    src: getAvatarUrl(data),
    appearance: appearance,
    type: isTeam(data) ? 'team' : 'person'
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.avatarItem
  }, /*#__PURE__*/React.createElement("div", {
    className: ax([styles.avatarItemTextWrapper])
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.avatarItemText
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, label, /*#__PURE__*/React.createElement(ElementAfter, props))))))) : null;
};